import { connect } from 'react-redux';
import AdditionalBlocks from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalBlocks);
